var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PopupBase,{attrs:{"open":_setup.isPopupOpen,"overlay-color":_setup.props.overlayColor,"overlay-max-opacity":_setup.props.overlayMaxOpacity,"styleTop":'25%'},on:{"closePopup":_setup.closePopup}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }